// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2MoHo","inputDescription":"styles_inputDescription__1QfWp"};